// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	line-height: 1.2;
	margin: 0;
}
html {
	color: #888;
	display: table;
	height: 100%;
	text-align: center;
	width: 100%;
}
body {
	display: table-cell;
	vertical-align: middle;
	padding: 2em;
}
h1 {
	color: #555;
	font-size: 2em;
	font-weight: 400;
}
p {
	margin: 0 auto;
	width: 280px;
}
pre {
	text-align: left;
	margin-top: 2rem;
}
@media only screen and (max-width: 280px) {
	body,
	p {
		width: 95%;
	}
	h1 {
		font-size: 1.5em;
		margin: 0 0 0.3em;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/error/ErrorPage.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,SAAS;AACV;AACA;CACC,WAAW;CACX,cAAc;CACd,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,YAAY;AACb;AACA;CACC,WAAW;CACX,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,YAAY;AACb;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC;;EAEC,UAAU;CACX;CACA;EACC,gBAAgB;EAChB,iBAAiB;CAClB;AACD","sourcesContent":["* {\n\tline-height: 1.2;\n\tmargin: 0;\n}\nhtml {\n\tcolor: #888;\n\tdisplay: table;\n\theight: 100%;\n\ttext-align: center;\n\twidth: 100%;\n}\nbody {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n\tpadding: 2em;\n}\nh1 {\n\tcolor: #555;\n\tfont-size: 2em;\n\tfont-weight: 400;\n}\np {\n\tmargin: 0 auto;\n\twidth: 280px;\n}\npre {\n\ttext-align: left;\n\tmargin-top: 2rem;\n}\n@media only screen and (max-width: 280px) {\n\tbody,\n\tp {\n\t\twidth: 95%;\n\t}\n\th1 {\n\t\tfont-size: 1.5em;\n\t\tmargin: 0 0 0.3em;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
